import React from 'react';
import { Typography, Box } from '@mui/material'; 
import './Footer.scss'; 

const date = new Date();
const year = date.getFullYear();

const Footer = () => {
  return (
    
    <Box component="footer" className="footer-container"> 
      <Typography variant="body1" color="inherit">
        &copy; {year} All Rights Reserved
      </Typography>
    </Box>
  );
};

export default Footer;
